import { ref } from 'vue';

import { useSocketMessage } from '@/composables/domains/chat/socket/useSocketMessage';
import { SocketState } from '@/stores/socket';
import { MessageCd } from '@/types/socket';

export function useMessagesMcb(entry) {
  const { handleMessageMM } = useSocketMessage();

  const state = ref(entry.state);
  const exceededUsageLimit = ref(entry.exceededUsageLimit);
  const evicted = ref(entry.evicted);
  const selectedChatId = ref(entry.selectedChatId);
  const connectionResponse = ref(entry.connectionResponse);

  // 메세지 처리
  const handleWebSocketMessage = async (data) => {
    let flag = data.slice(0, 2);

    const noOpFlags = ['sw', 'pi', 'tc'];
    if (noOpFlags.includes(flag)) return;

    switch (flag) {
      case 'ue':
        return (exceededUsageLimit.value = true);
      case 'nd':
        return (evicted.value = true);
    }

    if (data.length <= 10) {
      console.error(`No body message: ${data}`);
      return;
    }

    const message = JSON.parse(data.substring(10));

    switch (flag) {
      case 'ca':
        return handleMessageCa(message);
      case 'cd':
        handleMessageCd(message);
        break;
      case 'mm':
        handleMessageMM(message);
        break;
      default:
        break;
    }

    if (data instanceof ArrayBuffer) {
      data = new TextDecoder().decode(data);
    }

    if (typeof data === 'string') {
      flag = data.slice(0, 2);
      const length = parseInt(data.slice(2, 10), 10);

      if (data.length < 10 + length) {
        throw new Error('Data length mismatch');
      }

      switch (flag) {
        case 'er':
          return handleMessageEr(message);
      }
    }
  };

  // 연결 성공
  const handleMessageCa = ({ chatId }) => {
    localStorage.setItem('userIdConnected', localStorage.getItem('userId') ?? '');
    selectedChatId.value = chatId;
    connectionResponse.value = 2;
  };

  // 에러 발생
  const handleMessageEr = ({ code, errorCode }) => {
    if (code === '2002') entry.value.socketState = SocketState.ERROR_NO_HEADER;
    connectionResponse.value = errorCode;
  };

  const handleMessageCd = (messageCd: MessageCd) => {
    const { userId } = messageCd;

    if (userId === entry.userId) {
      connectionResponse.value = 9999;
    }
  };

  return {
    state,
    exceededUsageLimit,
    evicted,
    selectedChatId,
    connectionResponse,
    handleWebSocketMessage,
  };
}
